"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _creatable = require("./utils/creatable");
var _flatten_items = _interopRequireDefault(require("./utils/flatten_items"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var useAsyncDropdownFilter = function useAsyncDropdownFilter(itemFetcher) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    previouslyCreatedItems: []
  };
  var creatable = options.creatable,
    previouslyCreatedItems = options.previouslyCreatedItems;
  var _React$useState = React.useState([]),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    items = _React$useState2[0],
    setItems = _React$useState2[1];
  var previousItemFetcher = React.useRef(itemFetcher);
  var previousSearchTerm = React.useRef();
  var _React$useState3 = React.useState('initial'),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    loadingStatus = _React$useState4[0],
    setLoadingStatus = _React$useState4[1];
  var onSearchTermChange = React.useCallback(function (newSearchTerm) {
    var unchangedSearchTerm = (previousSearchTerm === null || previousSearchTerm === void 0 ? void 0 : previousSearchTerm.current) === newSearchTerm;
    var unchangedItemFetcher = (previousItemFetcher === null || previousItemFetcher === void 0 ? void 0 : previousItemFetcher.current) === itemFetcher;
    if (unchangedSearchTerm && unchangedItemFetcher) {
      return;
    }
    previousItemFetcher.current = itemFetcher;
    previousSearchTerm.current = newSearchTerm;
    setLoadingStatus('loading');
    setItems([]);
    itemFetcher(newSearchTerm).then(function (_ref) {
      var newItems = _ref.items;
      var flattenedItems = (0, _flatten_items["default"])(newItems, 0);
      setLoadingStatus('loaded');
      if (creatable) {
        setItems((0, _creatable.withCreatable)(flattenedItems, newSearchTerm, previouslyCreatedItems));
      } else {
        setItems(flattenedItems);
      }
    })["catch"](function (error) {
      if (!['debounced', 'stale'].includes(error)) {
        setLoadingStatus('error');
      }
    });
  }, [creatable, previouslyCreatedItems, itemFetcher]);
  (0, _reactUse.useEffectOnce)(function () {
    if (!itemFetcher.preventLoadOnMount) {
      onSearchTermChange('');
    }
  });
  return [items, loadingStatus, onSearchTermChange];
};
var _default = exports["default"] = useAsyncDropdownFilter;